import { Checkbox } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CardContentWrapper } from '../../../../solceller/form/components/styledComponents';
import { TermostatstyringRadio } from '../common/termostatstyringRadio';
import { StyledCard } from '../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { OppvarmingFormData } from '../../../types';
import { InstallasjonsArRadio } from '../../../../../components/installasjonsArRadio';

import { useOljeValidation } from './useOljeValidation';

export const Oljekamin = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming' });
  const { validateOljeSelection } = useOljeValidation();

  const oljeKaminSelected = watch('olje.value.kamin.selected');

  return (
    <StyledCard isActive={oljeKaminSelected}>
      <CardContentWrapper>
        <Checkbox
          aria-invalid={!!formState.errors.olje?.value?.kamin?.selected}
          label={t('olje.kamin.label')}
          {...register('olje.value.kamin.selected', {
            deps: ['olje.value.kjel.selected'],
            validate: validateOljeSelection,
            shouldUnregister: true
          })}
        />
        {oljeKaminSelected && (
          <Fragment>
            <InstallasjonsArRadio
              name="olje.value.kamin.value"
              translationKeyPrefix="form.oppvarming.olje.kamin.installasjonsAr" />
            <TermostatstyringRadio name="olje.value.kamin.value.termostatstyring" />
          </Fragment>
        )}
      </CardContentWrapper>
    </StyledCard>
  );
};
